module.exports = __webpack_public_path__ + "static/media/C-white.4fd7f732.png";